export default "__VITE_ASSET__B8v39yIv__"